export default __webpack_public_path__ + "static/media/logo.10b6f153.svg";